import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Booking from './components/Booking/Booking';
import PaymentSuccess from './components/PaymentSuccess/PaymentSuccess';
import Termeni from './components/Legal/Termeni';
import Confidentialitate from './components/Legal/Confidentialitate';
import Anulare from './components/Legal/Anulare';
import GDPR from './components/Legal/GDPR';
import Snowfall from 'react-snowfall';
import FallingText from './components/FallingText/FallingText';
import salBadge from './assets/images/sal.png';
import solBadge from './assets/images/sol.png';
import netopiaBadge from './assets/images/netopia-payments-seeklogo.png';
import logo from './assets/images/logo.png';
import { Link } from 'react-router-dom';

// Component pentru a afișa header-ul cu titlul corect
function AppContent() {
  const location = useLocation();
  const [showOverlay, setShowOverlay] = useState(() => {
    return location.pathname === '/' && !sessionStorage.getItem('fallingTextShown');
  });
  const [animationStarted, setAnimationStarted] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    if (location.pathname === '/' && showOverlay && !isMobile && !animationStarted) {
      const timer = setTimeout(() => {
        setAnimationStarted(true);
      }, 2000);
      
      return () => clearTimeout(timer);
    }
  }, [showOverlay, isMobile, animationStarted, location.pathname]);

  useEffect(() => {
    if (animationStarted) {
      const timer = setTimeout(() => {
        setShowOverlay(false);
        sessionStorage.setItem('fallingTextShown', 'true');
      }, 1500);
      
      return () => clearTimeout(timer);
    }
  }, [animationStarted]);

  const handleOverlayClick = () => {
    if (isMobile && !animationStarted) {
      setAnimationStarted(true);
    }
  };

  // Funcție pentru a determina titlul header-ului
  const getHeaderTitle = () => {
    switch (location.pathname) {
      case '/termeni':
        return 'Termeni și Condiții';
      case '/confidentialitate':
        return 'Politică de Confidențialitate';
      case '/anulare':
        return 'Politica de Anulare';
      case '/gdpr':
        return 'Politica GDPR';
      case '/payment-success':
        return 'Confirmare Plată';
      default:
        return 'Rezervări online – Schi & Snowboard Cavnic, Maramureș';
    }
  };

  return (
    <>
      <Snowfall
        color="#ffffff"
        snowflakeCount={80}
        style={{
          position: 'fixed',
          width: '100vw',
          height: '100vh',
          zIndex: 1
        }}
        radius={[0.5, 3.0]}
        speed={[0.5, 2.0]}
        wind={[-0.5, 1.0]}
      />
      
      {showOverlay && (
        <div 
          className={`falling-text-overlay ${animationStarted ? 'animation-started' : ''}`}
          onClick={handleOverlayClick}
        >
          <div className="falling-text-wrapper">
            <FallingText
              text="Școala de Schi Fulg de Nea Icoana Cavnic Maramureș"
              highlightWords={["Fulg", "Nea"]}
              highlightClass="highlighted"
              trigger={animationStarted ? 'auto' : 'manual'}
              backgroundColor="transparent"
              wireframes={false}
              gravity={1.2}
              fontSize="3.5rem"
              mouseConstraintStiffness={0.9}
            />
          </div>
          {isMobile && !animationStarted && (
            <div className="tap-hint">Atinge ecranul pentru a începe</div>
          )}
        </div>
      )}

      <div className="App">
        {/* HEADER GLOBAL */}
        <div className="booking-header">
          <div className="header-content">
            <Link to="/" className="logo-link">
              <img src={logo} alt="Școala de Schi Fulg de Nea" className="header-logo" />
            </Link>
            <h1 className="header-title">{getHeaderTitle()}</h1>
            <a href="https://schitaberemm.ro/" className="back-to-site-btn" rel="noopener noreferrer">
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
    <polyline points="9 22 9 12 15 12 15 22"/>
  </svg>
  <span>Înapoi la pagina principala</span>
</a>
          </div>
        </div>

        {/* ROUTES */}
        <Routes>
          <Route path="/" element={<Booking />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/termeni" element={<Termeni />} />
          <Route path="/confidentialitate" element={<Confidentialitate />} />
          <Route path="/anulare" element={<Anulare />} />
          <Route path="/gdpr" element={<GDPR />} />
        </Routes>

        {/* FOOTER GLOBAL */}
        <footer className="site-footer">
          <div className="footer-container">
            <div className="footer-content">
              <h3 className="footer-title">Școala de Schi Fulg de Nea</h3>
              <p className="footer-subtitle">Icoana Cavnic, Maramureș</p>
              
              <div className="footer-info-box">
                <p className="company-name">SC CLADIDAV S.R.L.</p>
                <p>CUI: 15903651 | J24/1284/2003</p>
                <p>Str. Privighetorii 36, Maramureș, 430324</p>
                <p>Email: m_adi_i@yahoo.com | Tel: 0745573126</p>
              </div>
              
              <div className="footer-links">
                <a href="/termeni">Termeni și condiții</a>
                <span>|</span>
                <a href="/confidentialitate">Politica de confidențialitate</a>
                <span>|</span>
                <a href="/anulare">Politica de anulare</a>
                <span>|</span>
                <a href="/gdpr">GDPR</a>
              </div>

              <div className="footer-logos">
                <a href="https://anpc.ro/ce-este-sal/" target="_blank" rel="noopener noreferrer" title="ANPC - Soluționarea Alternativă a Litigiilor">
                  <img src={salBadge} alt="ANPC SAL" className="footer-logo" />
                </a>
                <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" title="Platforma SOL">
                  <img src={solBadge} alt="Platforma SOL" className="footer-logo" />
                </a>
                <a href="https://netopia-payments.com" target="_blank" rel="noopener noreferrer" title="NETOPIA Payments">
                  <img src={netopiaBadge} alt="NETOPIA Payments" className="footer-logo footer-logo-netopia" />
                </a>
              </div>
              
              <div className="footer-copyright">
                © 2025 SC CLADIDAV S.R.L. Toate drepturile rezervate.
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;